export default __webpack_public_path__ + "soil-500-d42ecd6cba5e82888bcf14f3258699b2.png";